export class SignRecupMethod {
  label: string;
  value: number;

  constructor(label: string, value: number) {
    this.label = label;
    this.value = value;
  }
}

export const RecupMethodChoices = {
  DUOPROP: new SignRecupMethod('Recup duoprop', 0),
  KADER: new SignRecupMethod('Recup op Kader', 1),
  DESTROY: new SignRecupMethod('Niet recupereren', 2),
};

export const RecupMethodChoiceArray = Object.values(RecupMethodChoices);
